import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

// Redux
import {
    getSearchText,
    getSelectedFilters,
    getDocumentSearchText,
} from "../store/selectors";
import {
    inputSearchText,
    saveDateResults,
    saveDocumentSearchText,
    saveSearchResults,
    switchLoadingToFalse,
    switchLoadingToTrue,
} from "../store/actions";

// API
import {
    buildFilters,
    buildSemanticFilters,
    searchDateGroups,
    semanticSearch,
    getAbstractsMap,
    search,
    searchDocument,
    searchDocumentSemantic,
} from "../backend/search";

// Utils
import { pick } from "lodash";
import { joinFilters } from "../utils/search";

const useSearch = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const startSearch = async (text, page = 1, filters = {}, sort = {}) => {
        dispatch(switchLoadingToTrue());

        // if (!history.location.pathname.includes("/results?restart=true")) {
        //     history.push("/results");
        // }

        try {
            const builtGeneralFilters = buildFilters(filters);

            if (text !== "") {
                dispatch(saveDocumentSearchText(""));
            }

            // Se hace una búsqueda semántica con filtro
            const [searchResponse, dateGroupsResponse] = await Promise.all([
                search(text, builtGeneralFilters, page, sort),
                searchDateGroups(text, builtGeneralFilters),
            ]);

            // Se consultan los abstracts
            // if (text.length > 0 && text !== "*") {
            //     searchResponse.abstracts = await getAbstractsMap(
            //         searchResponse.data.hits.hits,
            //         text
            //     );
            // } else {
            //     let filter_text = joinFilters(filters);

            //     if (filter_text !== "") {
            //         searchResponse.abstracts = await getAbstractsMap(
            //             searchResponse.data.hits.hits,
            //             filter_text
            //         );
            //     } else {
            //         searchResponse.abstracts = {};
            //     }
            // }

            dispatch(saveDateResults(dateGroupsResponse));
            dispatch(saveSearchResults(searchResponse));
            dispatch(switchLoadingToFalse());
        } catch (err) {
            console.log(err);
            dispatch(saveDocumentSearchText(""));
            dispatch(inputSearchText(""));
            dispatch(saveSearchResults([]));

            dispatch(switchLoadingToFalse());
        }
    };

    const startSearchByDocument = async (
        text,
        page = 1,
        filters = {},
        sort = {},
        filterDoc = ""
    ) => {
        dispatch(switchLoadingToTrue());

        // if (!history.location.pathname.includes("/results?restart=true")) {
        //     history.push("/results");
        // }

        try {
            const builtGeneralFilters = buildFilters(filters);
            dispatch(inputSearchText(""));

            // Se hace una búsqueda semántica con filtro
            const [searchResponse, dateGroupsResponse] = await Promise.all([
                searchDocumentSemantic(
                    text,
                    builtGeneralFilters,
                    page,
                    filterDoc,
                    sort
                ),
                // searchDocument(text, builtGeneralFilters, page, sort),
                // searchDateGroups(text, []),
            ]);

            // // Se consultan los abstracts
            // if (text.length > 0 && text !== "*") {
            //     searchResponse.abstracts = await getAbstractsMap(
            //         searchResponse.data.hits.hits,
            //         text
            //     );
            // } else {
            //     let filter_text = joinFilters(filters);

            //     if (filter_text !== "") {
            //         searchResponse.abstracts = await getAbstractsMap(
            //             searchResponse.data.hits.hits,
            //             filter_text
            //         );
            //     } else {
            //         searchResponse.abstracts = {};
            //     }
            // }

            dispatch(saveDateResults(dateGroupsResponse));
            dispatch(saveSearchResults(searchResponse));
            dispatch(switchLoadingToFalse());
        } catch (err) {
            console.log(err);
            dispatch(saveDocumentSearchText(""));
            dispatch(inputSearchText(""));
            dispatch(saveSearchResults([]));

            dispatch(switchLoadingToFalse());
        }
    };

    return { startSearch, startSearchByDocument };
};

export default useSearch;
